import React from 'react';
import { Container } from '@components/Container';
import { Section } from '@components/Section';
import { PrivacyPolicyForm } from '@pages/PrivacyPolicy/components/PrivacyPolicyForm';

export const PrivacyPolicy = () => (
  <div className="main-content">
    <Container size="lg">
      <div className="panel">
        <Section containerSize="md">
          <PrivacyPolicyForm />
        </Section>
      </div>
    </Container>
  </div>
);
